import React, { PropTypes } from 'react';
import TextInput from '../../common/TextInput';
import SelectInput from '../../common/SelectInput';
import Button from '../../common/Button';
import * as selectLists from '../../../constants/FilterSelectLists';


const CaseDataFilterRow = ({
  enteringData,
  onSelect,
  setFilters,
  clearFilters,
  newFilterValues
}) => {
  let filters = [
    <p className="filter-instructions" key="instructions"> To filter your list of 300/301 data, input your criteria in one or more fields below, and then click the "Filter" button to update the list.</p>,
    <div className="row">
      <div className="col-lg-12 establishments-search-box" key="case_number">
        <label htmlFor="case_number">Case Number</label>
        <TextInput
          type="text"
          placeholder="Case Number"
          name="case_number"
          onChange={enteringData}
          value={newFilterValues.case_number} />
      </div>
    </div>,
    <div className="row">
      <div className="col-lg-6 establishments-search-box" key="case_classification">
        <label htmlFor="case_classification">Most Serious Outcome:</label>
        <SelectInput
          name="case_classification"
          options={selectLists.caseDataCaseClassification}
          defaultOption="Most Serious Outcome"
          onChange={onSelect}
          value={newFilterValues.case_classification}
        />
      </div>
      <div className="col-lg-6 establishments-search-box" key="injury_illness_type">
        <label htmlFor="injury_illness_type">Injury Type:</label>
        <SelectInput
          name="injury_illness_type"
          options={selectLists.caseDataInjuryType}
          defaultOption="Injury Type"
          onChange={onSelect}
          value={newFilterValues.injury_illness_type}
        />
      </div>
    </div>,
    <br />,
    <div className="row" key="buttons">
      <div className="container">
        <Button
          value="Clear"
          disabled={false}
          onClick={clearFilters}
          className="btn-cancel"
          title="Clear all the filters"
        />

        <Button
          value="Filter"
          disabled={false}
          onClick={setFilters}
          className="filter-establishment-list"
          title="Filter 300/301 Data"
        />
      </div>
    </div>
  ];
  return (<div className="">
    <div className="filter-group col-xs-12 non-mobile">
      <div>
        <h2 className="filter-title">Search for 300/301 Data</h2>
      </div>
      {filters}
    </div>
  </div>
  );
};

CaseDataFilterRow.propTypes = {
  enteringData: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  setFilters: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  newFilterValues: PropTypes.object.isRequired,
  toggleInactive: PropTypes.func.isRequired


};


export default CaseDataFilterRow;








/** WEBPACK FOOTER **
 ** ./src/components/caseData/CaseDataManagement/CaseDataFilterRow.js
 **/